import React from 'react';
import {
  Card, Row, Col, Input, Button, Modal, Table, Tag, Spin, Empty,
  Typography, Tooltip,
} from 'antd';
import {
  SyncOutlined, PrinterOutlined, ReloadOutlined, WarningOutlined,
  ArrowRightOutlined, InboxOutlined, HistoryOutlined,
  ExclamationCircleOutlined, CheckCircleOutlined, DatabaseOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import { toastSuccess, toastError } from '../../utils/toast';

const { Text } = Typography;
const { TextArea } = Input;

const configClass = {
  title: 'Sinkronisasi Nomor Notice',
  apiUrl: { sinkron: 'transaksi/api/sinkron-notice/' },
};

const config = new Config();

/**
 * Penyamaan posisi nomor notice aplikasi dengan blanko fisik di printer.
 * - Maju  : printer merusak blanko, nomor gap dicatat rusak, counter lompat.
 * - Mundur: counter aplikasi terlanjur di depan, nomor utuh masuk pool
 *           dan otomatis dipakai ulang lebih dulu saat pembayaran.
 * Berjalan instan tanpa approval - digate hak_akses transaksi_sinkron_notice
 * dan setiap operasi tercatat di riwayat (LogSinkronNotice).
 */
class SinkronNotice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPosisi: false,
      posisi: null,          // response GET posisi
      posisiErr: '',
      loadingPreview: false,
      preview: null,         // response POST preview:true
      modalKonfirmasi: false,
      loadingSubmit: false,
      nomorFisik: '',
      keterangan: '',
      loadingRiwayat: false,
      riwayat: [],
      isMobile: window.innerWidth <= 768,
    };
  }

  componentDidMount() {
    this.props.initHandler();
    this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
    window.addEventListener('resize', this._handleResize);
    this.fetchPosisi();
    this.fetchRiwayat();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleResize);
  }

  _extractError = (resp, fallback) => {
    if (resp && typeof resp === 'object' && resp.error) return resp.error;
    if (typeof resp === 'string' && resp) return resp;
    return fallback;
  };

  fetchPosisi = () => {
    this.setState({ loadingPosisi: true, posisiErr: '' });
    this.props.ajaxViewHandler('get', configClass.apiUrl.sinkron)
      .then(() => {
        if (this.props.isSuccess) {
          this.setState({ posisi: this.props.responseMsg });
        } else {
          this.setState({
            posisi: null,
            posisiErr: this._extractError(this.props.responseMsg, 'Gagal memuat posisi nomor notice'),
          });
        }
        this.setState({ loadingPosisi: false });
      }).catch(() => this.setState({ loadingPosisi: false, posisiErr: 'Gagal memuat posisi nomor notice' }));
  };

  fetchRiwayat = () => {
    this.setState({ loadingRiwayat: true });
    this.props.ajaxViewHandler('get', configClass.apiUrl.sinkron + '?riwayat=1')
      .then(() => {
        if (this.props.isSuccess) {
          this.setState({ riwayat: (this.props.responseMsg && this.props.responseMsg.riwayat) || [] });
        }
        this.setState({ loadingRiwayat: false });
      }).catch(() => this.setState({ loadingRiwayat: false }));
  };

  handlePeriksa = () => {
    const { nomorFisik, keterangan } = this.state;
    const nomor = parseInt(nomorFisik, 10);
    if (!nomor || nomor <= 0) {
      toastError('Isi nomor blanko fisik berikutnya terlebih dahulu');
      return;
    }
    this.setState({ loadingPreview: true });
    this.props.ajaxHandler('post', configClass.apiUrl.sinkron,
      { nomor_fisik_berikutnya: nomor, keterangan, preview: true }, false, true)
      .then(() => {
        if (this.props.isSuccess) {
          this.setState({ preview: this.props.responseMsg, modalKonfirmasi: true });
        } else {
          toastError(this._extractError(this.props.responseMsg, 'Gagal memeriksa nomor'), 5);
        }
        this.setState({ loadingPreview: false });
      }).catch(() => {
        toastError('Gagal memeriksa nomor, coba lagi');
        this.setState({ loadingPreview: false });
      });
  };

  handleKonfirmasi = () => {
    const { nomorFisik, keterangan } = this.state;
    this.setState({ loadingSubmit: true });
    this.props.ajaxHandler('post', configClass.apiUrl.sinkron,
      { nomor_fisik_berikutnya: parseInt(nomorFisik, 10), keterangan }, false, true)
      .then(() => {
        if (this.props.isSuccess) {
          const data = this.props.responseMsg || {};
          toastSuccess(data.arah === 'maju'
            ? `Sinkronisasi selesai - ${(data.nomor_rusak_baru || []).length} nomor dicatat rusak, nomor berikutnya ${data.nomor_berikutnya_baru}`
            : `Sinkronisasi selesai - ${(data.nomor_masuk_pool || []).length} nomor masuk pool dan dipakai ulang lebih dulu`, 5);
          this.setState({ modalKonfirmasi: false, preview: null, nomorFisik: '', keterangan: '' });
          this.fetchPosisi();
          this.fetchRiwayat();
        } else {
          toastError(this._extractError(this.props.responseMsg, 'Gagal menyimpan sinkronisasi'), 5);
        }
        this.setState({ loadingSubmit: false });
      }).catch(() => {
        toastError('Gagal menyimpan sinkronisasi, coba lagi');
        this.setState({ loadingSubmit: false });
      });
  };

  // ── Kartu posisi ─────────────────────────────────────────────
  renderPosisi = () => {
    const { posisi, loadingPosisi, posisiErr, isMobile } = this.state;
    if (loadingPosisi) return <div style={{ textAlign: 'center', padding: 30 }}><Spin /></div>;
    if (posisiErr) return (
      <div style={{ background: '#fff2f0', border: '1px solid #ffccc7', borderRadius: 10,
                    padding: '12px 16px', color: '#a8071a', fontSize: 13 }}>
        <WarningOutlined style={{ marginRight: 8 }} />{posisiErr}
      </div>
    );
    if (!posisi) return null;

    const stats = [
      { label: 'Kode Notice', value: posisi.kode || '-', icon: <DatabaseOutlined /> },
      { label: 'Nomor Terakhir Terpakai', value: posisi.nomor_terakhir, icon: <CheckCircleOutlined /> },
      { label: 'Nomor Berikutnya (Aplikasi)', value: posisi.nomor_berikutnya, utama: true, icon: <PrinterOutlined /> },
      posisi.box_aktif && {
        label: `Box Aktif #${posisi.box_aktif.nomor_box}`,
        value: `${posisi.box_aktif.nomor_awal} – ${posisi.box_aktif.nomor_akhir}`,
        sub: `sisa ${posisi.box_aktif.sisa} nomor`,
        icon: <InboxOutlined />,
      },
      {
        label: 'Pool Nomor Kembali',
        value: posisi.pool_count,
        sub: posisi.pool_count > 0
          ? `dipakai ulang lebih dulu: ${(posisi.pool_preview || []).map(p => p.nomor_notice).join(', ')}${posisi.pool_count > 5 ? ', …' : ''}`
          : 'kosong',
        icon: <ReloadOutlined />,
      },
    ].filter(Boolean);

    return (
      <Row gutter={[12, 12]}>
        {stats.map(s => (
          <Col xs={24} sm={12} md={s.utama ? 6 : 5} flex={isMobile ? undefined : 'auto'} key={s.label}>
            <div style={{
              borderRadius: 10, height: '100%',
              padding: '12px 16px',
              background: s.utama ? 'linear-gradient(135deg, #0f2847, #1e4d8a)' : '#f6f8fc',
              border: s.utama ? 'none' : '1px solid #e0e7f0',
            }}>
              <div style={{ fontSize: 11, color: s.utama ? 'rgba(255,255,255,0.75)' : '#888' }}>
                <span style={{ marginRight: 6 }}>{s.icon}</span>{s.label}
              </div>
              <div style={{
                fontSize: s.utama ? 26 : 20, fontWeight: 700, marginTop: 2,
                color: s.utama ? '#fff' : '#0f2847', letterSpacing: 1,
              }}>{s.value}</div>
              {s.sub && <div style={{ fontSize: 11, marginTop: 2, color: s.utama ? 'rgba(255,255,255,0.7)' : '#999' }}>{s.sub}</div>}
            </div>
          </Col>
        ))}
      </Row>
    );
  };

  // ── Riwayat ──────────────────────────────────────────────────
  renderRiwayat = () => {
    const { riwayat, loadingRiwayat, isMobile } = this.state;
    const arahTag = (r) => (
      <Tag color={r.arah === 'maju' ? 'volcano' : 'blue'} style={{ borderRadius: 20, fontSize: 11 }}>
        {r.arah === 'maju' ? '⚠ Maju (dicatat rusak)' : '↩ Mundur (masuk pool)'}
      </Tag>
    );
    if (loadingRiwayat) return <div style={{ textAlign: 'center', padding: 30 }}><Spin /></div>;
    if (!riwayat.length) return <Empty description="Belum ada riwayat sinkronisasi" style={{ padding: 30 }} />;

    if (isMobile) {
      return riwayat.map(r => (
        <Card key={r.id} size="small" style={{ marginBottom: 10, borderRadius: 10, borderLeft: '4px solid #1e4d8a' }}
              bodyStyle={{ padding: '12px 14px' }}>
          {arahTag(r)}
          <div style={{ marginTop: 6, fontWeight: 700, color: '#0f2847', letterSpacing: 1 }}>
            {r.kode_notice} {r.nomor_dari} – {r.nomor_ke}
            <Text type="secondary" style={{ fontSize: 11, marginLeft: 8 }}>({r.jumlah} nomor)</Text>
          </div>
          <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
            {r.pegawai} · {r.created_at}
          </div>
          {r.keterangan && <div style={{ fontSize: 12, color: '#888', marginTop: 2, fontStyle: 'italic' }}>"{r.keterangan}"</div>}
        </Card>
      ));
    }

    const cols = [
      { title: 'Waktu', dataIndex: 'created_at', width: 140,
        render: v => <span style={{ fontSize: 12, whiteSpace: 'nowrap' }}>{v}</span> },
      { title: 'Arah', dataIndex: 'arah', width: 180, render: (_, r) => arahTag(r) },
      { title: 'Rentang Nomor', width: 170,
        render: (_, r) => <Text strong style={{ letterSpacing: 1, fontSize: 12 }}>
          {r.kode_notice} {r.nomor_dari} – {r.nomor_ke}</Text> },
      { title: 'Jumlah', dataIndex: 'jumlah', width: 80, align: 'center',
        render: v => <span style={{ fontSize: 12 }}>{v}</span> },
      { title: 'Petugas', dataIndex: 'pegawai', width: 150,
        render: v => <span style={{ fontSize: 12 }}>{v}</span> },
      { title: 'Keterangan', dataIndex: 'keterangan', ellipsis: true,
        render: v => <span style={{ fontSize: 12, color: '#888' }}>{v || '-'}</span> },
    ];
    return <Table rowKey="id" columns={cols} dataSource={riwayat} size="small"
                  pagination={false} scroll={{ x: 800 }} />;
  };

  // ── Modal konfirmasi (preview) ───────────────────────────────
  renderModalKonfirmasi = () => {
    const { modalKonfirmasi, preview, loadingSubmit } = this.state;
    if (!preview) return null;
    const maju = preview.arah === 'maju';
    const nomorList = maju ? (preview.nomor_rusak_baru || []) : (preview.nomor_masuk_pool || []);
    return (
      <Modal title={null} centered open={modalKonfirmasi} footer={null}
             closable={false} width="min(92vw, 500px)" className="modal-peringatan"
             onCancel={() => this.setState({ modalKonfirmasi: false })}>
        <div className="peringatan-modal-header"
             style={maju ? undefined : { background: 'linear-gradient(135deg, #0f2847, #1e4d8a)' }}>
          <div className="peringatan-modal-icon">
            {maju ? <WarningOutlined /> : <ReloadOutlined />}
          </div>
          <div>
            <div className="peringatan-modal-title">
              {maju ? 'Konfirmasi Sinkronisasi Maju' : 'Konfirmasi Sinkronisasi Mundur'}
            </div>
            <div className="peringatan-modal-subtitle">
              {maju ? 'Nomor yang terlewati dicatat RUSAK permanen' : 'Nomor utuh dikembalikan ke pool'}
            </div>
          </div>
        </div>
        <div className="peringatan-modal-body">
          <div style={{ marginBottom: 10 }}>
            {maju ? (
              <span>
                <b>{nomorList.length} nomor</b> berikut akan dicatat <b>RUSAK</b> dan
                otomatis dilompati saat pembayaran:
              </span>
            ) : (
              <span>
                <b>{nomorList.length} nomor</b> berikut akan masuk pool dan
                <b> dipakai ulang lebih dulu</b> pada pembayaran berikutnya:
              </span>
            )}
          </div>
          <div style={{
            background: maju ? '#fff2f0' : '#f6f8fc',
            border: `1px solid ${maju ? '#ffccc7' : '#e0e7f0'}`,
            borderRadius: 8, padding: '10px 14px', marginBottom: 12,
            fontWeight: 700, letterSpacing: 1, color: maju ? '#a8071a' : '#0f2847',
            maxHeight: 120, overflowY: 'auto', fontSize: 14,
          }}>
            {preview.kode} {nomorList.join(', ')}
          </div>
          {(preview.nomor_sudah_rusak || []).length > 0 && (
            <div style={{ fontSize: 12, color: '#888', marginBottom: 10 }}>
              Sudah tercatat rusak sebelumnya (dilewati): {preview.nomor_sudah_rusak.join(', ')}
            </div>
          )}
          <div style={{ fontSize: 13 }}>
            Nomor berikutnya yang diterbitkan aplikasi menjadi{' '}
            <Text strong style={{ fontSize: 15 }}>{preview.kode} {preview.nomor_berikutnya_baru}</Text>
            {' '}<ArrowRightOutlined style={{ fontSize: 11, color: '#999' }} />{' '}
            pastikan sama dengan blanko fisik di printer sebelum melanjutkan.
          </div>
        </div>
        <div className="peringatan-modal-footer">
          <Button onClick={() => this.setState({ modalKonfirmasi: false })}
                  style={{ borderRadius: 8, marginRight: 8 }} disabled={loadingSubmit}>
            Batal
          </Button>
          <Button type={maju ? 'danger' : 'primary'} loading={loadingSubmit}
                  onClick={this.handleKonfirmasi}
                  style={{ borderRadius: 8, fontWeight: 600,
                           ...(maju ? {} : { background: '#0f2847', borderColor: '#0f2847' }) }}>
            {maju ? 'Ya, Catat Rusak & Lompati' : 'Ya, Masukkan ke Pool'}
          </Button>
        </div>
      </Modal>
    );
  };

  render() {
    const { nomorFisik, keterangan, loadingPreview, loadingPosisi, isMobile, posisi } = this.state;
    return (
      <div>
        <Helmet><title>{configClass.title + ' | ' + config.get_site_info().name}</title></Helmet>

        {/* Header */}
        <Card bodyStyle={{ padding: 0 }} style={{
          borderRadius: 14, overflow: 'hidden', marginBottom: 16,
          boxShadow: '0 4px 20px rgba(0,0,0,0.10)', border: 'none',
        }}>
          <div style={{ background: 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 100%)',
                        padding: '20px 24px', display: 'flex', alignItems: 'center',
                        justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ width: 50, height: 50, borderRadius: 12, background: 'rgba(255,255,255,0.15)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 22, color: '#fff' }}>
                <SyncOutlined />
              </div>
              <div>
                <div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>{configClass.title}</div>
                <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
                  Samakan posisi nomor aplikasi dengan blanko fisik di printer (kasus blanko rusak digulung printer)
                </div>
              </div>
            </div>
            <Tooltip title="Muat ulang posisi">
              <Button icon={<ReloadOutlined />} loading={loadingPosisi}
                onClick={() => { this.fetchPosisi(); this.fetchRiwayat(); }}
                style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
                {!isMobile && 'Muat Ulang'}
              </Button>
            </Tooltip>
          </div>
        </Card>

        {/* Posisi saat ini */}
        <Card title={<span style={{ fontSize: 14, fontWeight: 700, color: '#0f2847' }}>
                <DatabaseOutlined style={{ marginRight: 8 }} />Posisi Menurut Aplikasi</span>}
              style={{ borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: 'none', marginBottom: 16 }}
              bodyStyle={{ padding: isMobile ? 12 : '16px 20px' }}>
          {this.renderPosisi()}
        </Card>

        {/* Form sinkronisasi */}
        <Card title={<span style={{ fontSize: 14, fontWeight: 700, color: '#0f2847' }}>
                <PrinterOutlined style={{ marginRight: 8 }} />Posisi Fisik di Printer</span>}
              style={{ borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: 'none', marginBottom: 16 }}
              bodyStyle={{ padding: isMobile ? 12 : '16px 20px' }}>
          <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8,
                        padding: '8px 14px', marginBottom: 14, fontSize: 12, color: '#614700' }}>
            <ExclamationCircleOutlined style={{ marginRight: 8, color: '#faad14' }} />
            Lihat nomor pada blanko kosong yang saat ini siap dicetak di printer, lalu masukkan di bawah.
            Nomor yang terlewati (karena rusak digulung printer) akan dicatat rusak otomatis.
          </div>
          <Row gutter={[12, 12]} align="bottom">
            <Col xs={24} sm={10} md={7}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Nomor blanko fisik berikutnya
              </div>
              <Input size="large" type="number" min={1} placeholder={posisi ? String(posisi.nomor_berikutnya) : 'cth: 1053'}
                value={nomorFisik} className="no-uppercase"
                onChange={e => this.setState({ nomorFisik: e.target.value })}
                onPressEnter={this.handlePeriksa}
                style={{ borderRadius: 8, fontWeight: 700, letterSpacing: 1 }} />
            </Col>
            <Col xs={24} sm={14} md={11}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                Keterangan (opsional)
              </div>
              <TextArea rows={1} autoSize={{ minRows: 1, maxRows: 2 }} className="no-uppercase"
                placeholder="cth: printer macet menggulung 3 blanko"
                value={keterangan}
                onChange={e => this.setState({ keterangan: e.target.value })}
                style={{ borderRadius: 8 }} />
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Button type="primary" block={isMobile} size="large" icon={<SyncOutlined />}
                loading={loadingPreview} onClick={this.handlePeriksa}
                style={{ borderRadius: 8, fontWeight: 600, background: '#0f2847', borderColor: '#0f2847' }}>
                Periksa & Sinkronkan
              </Button>
            </Col>
          </Row>
        </Card>

        {/* Riwayat */}
        <Card title={<span style={{ fontSize: 14, fontWeight: 700, color: '#0f2847' }}>
                <HistoryOutlined style={{ marginRight: 8 }} />Riwayat Sinkronisasi</span>}
              style={{ borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: 'none' }}
              bodyStyle={{ padding: isMobile ? 12 : '16px 20px' }}>
          {this.renderRiwayat()}
        </Card>

        {this.renderModalKonfirmasi()}
      </div>
    );
  }
}

const mapStateToProps = state => state.configReducers;
export default connect(mapStateToProps, { initHandler, ajaxViewHandler, ajaxHandler, setConfig })(SinkronNotice);
